"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var uriParser_1 = require("./uriParser");
var mergePaths = function (left, right) {
    var leftPath = left.replace(/\/$/, '');
    var rightPath = right.replace(/^\//, '');
    return leftPath + "/" + rightPath;
};
exports.mergePaths = mergePaths;
var mergeBaseUriPiece = function (baseUriPiece, extensionPiece) {
    if (typeof extensionPiece === 'undefined') {
        return baseUriPiece;
    }
    if (typeof extensionPiece === 'function') {
        return extensionPiece(baseUriPiece);
    }
    return extensionPiece;
};
var mergeBaseUri = function (baseUri, extension) {
    var parsedBaseUri = new uriParser_1.URIParser(baseUri).parse();
    var scheme = mergeBaseUriPiece(parsedBaseUri.scheme, extension.scheme);
    var host = mergeBaseUriPiece(parsedBaseUri.host, extension.host);
    var port = mergeBaseUriPiece(parsedBaseUri.port, extension.port);
    var path = mergeBaseUriPiece(parsedBaseUri.path, extension.path);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var query = mergeBaseUriPiece(parsedBaseUri.query || '', extension.query);
    return {
        host: host,
        path: path,
        port: port,
        query: query,
        scheme: scheme,
    };
};
exports.mergeBaseUri = mergeBaseUri;
//# sourceMappingURL=helpers.js.map